import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { CMS } from '../../../utils/CMS';
import { setTripType } from '../../../redux/currentSearch/actions';
import { TripType } from '../../../models';
import { SlideGroupContext, TRANSITION_DURATION } from '../../../components/SlideManager';
import { ExtraBottomPadding } from './ExtraBottomPadding';
import { ABUtils } from '../../../utils';

const style = {
    borderRadius: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 2,
};

export const OfferOneWay = ({ dates, setTripType }) => {
    const { close } = React.useContext(SlideGroupContext);
    const { isCssVariationMobile } = ABUtils.getABs();
    const [departure, returnDate] = dates;
    if (!departure || returnDate) {
        return <React.Fragment />;
    }

    const setOneWay = () => {
        close();
        setTimeout(() => setTripType(TripType.ONE_WAY), TRANSITION_DURATION * 2);
    };

    const wrapperClassName = classNames({
        'odf-space-inner-left-m odf-space-inner-right-s odf-space-inner-top-s odf-space-inner-bottom-s': !isCssVariationMobile,
        'safari-extra-padding-bottom': !isCssVariationMobile,
        'prisma-responsive-space-horizontal odf-space-inner-top-m odf-space-inner-bottom-m prisma-elevation-1': isCssVariationMobile,
        'safari-extra-padding-bottom-lg': isCssVariationMobile,
        'odf-box': true,
    });
    const buttonClassName = classNames({
        'odf-btn odf-btn-secondary': !isCssVariationMobile,
        'prisma-btn prisma-btn-default prisma-btn-round': isCssVariationMobile,
    });

    return (
        <ExtraBottomPadding>
            <div
                className={wrapperClassName}
                style={style}
            >
                <CMS id="calendar.especialOptions.return.msg" />
                <button type="button" className={buttonClassName} onClick={setOneWay}>
                    <CMS id="calendar.especialOptions.button.oneWay" />
                </button>
            </div>
        </ExtraBottomPadding>
    );
};

OfferOneWay.propTypes = {
    setTripType: PropTypes.func.isRequired,
    dates: PropTypes.arrayOf(Date).isRequired,
};

export const ConnectedOfferOneWay = connect(null, {
    setTripType,
})(OfferOneWay);
